import { useContext, useEffect } from 'react';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { getStyles } from './NavBar.style';
import { LocalizationContext } from '@context/LocalizationContext';
import { useLocation } from 'react-router-dom';
import { config, Localization } from '@branding/config';
import { LanguageSelection } from '../LanguageSelection/LanguageSelection';

interface INavBarComponentProps {
	isQuestionTrailDisplayed: boolean;
	showLanguageSelector?: boolean;
}

export default function NavBarComponent({
	isQuestionTrailDisplayed,
	showLanguageSelector = true,
}: INavBarComponentProps) {
	const paramLogo = new URLSearchParams(window.location.search).get('logo'); // Get logo from url
	const { setLanguage } = useContext(LocalizationContext); // Use this to change language
	const theme: any = useTheme();
	const styles = getStyles(theme);
	const { SupportedLanguages } = Localization;

	const { search } = useLocation();
	const params = new URLSearchParams(search);
	const langParam = params.get('lang');
	const logoUrl = `${config.brandingEndpoint}/bank_logo.png`;

	useEffect(() => {
		if (langParam && SupportedLanguages.includes(langParam)) {
			setLanguage(langParam);
		}
	}, [langParam]);
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Stack
			position={'sticky'}
			direction={'row'}
			alignItems={'center'}
			maxHeight={'48px'}
			paddingInline={{
				xxs: '16px',
				xs: '16px',
				sm: '16px',
				md: '24px',
				lg: '48px',
				xl: '120px',
			}}
			paddingTop={{
				xxs: '16px',
				xs: '16px',
				sm: '16px',
				md: '24px',
				lg: '32px',
				xl: '24px',
			}}
			justifyContent={'space-between'}>
			<Stack sx={styles.logoContainer}>
				<img
					alt="Logo"
					className="logo"
					style={{ ...styles.logo, maxHeight: isMobile ? '25px' : '40px' }}
					src={paramLogo ?? logoUrl}
				/>
			</Stack>
			{showLanguageSelector && <LanguageSelection />}
		</Stack>
	);
}
